<template lang="html">
<div class="pgInner atvEdit">

    <div class="headBar">新建商协会</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params1" :rules="rules" inline-message="true" :show-message="true">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">
                        <span class="dot">*</span>
                        <span>商协会名</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params1.title" placeholder="请输入商协会名称"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>入会条件</span>
                     </div>
                     <div class="bContent">
                         <textEditor id="textEditor1" ref="textEditor1" :inContent="params2.membershipRequirements" height="300" />

                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">提交材料</div>
                     <div class="bContent">
                         <textEditor id="textEditor2" ref="textEditor2" :inContent="params2.submitMaterial" height="300" />

                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">入会流程</div>
                     <div class="bContent">
                         <textEditor id="textEditor3" ref="textEditor3" :inContent="params2.membershipProcess" height="300" />

                     </div>
                 </div>

                 <div class="text-block tag-block clearfix">
                     <div class="bName">标签</div>
                     <div class="bContent">
                          <tag-select :selectTags="params1.tagNames" paramsKey="tagNames" @selectChange="tagChange" />
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">联系人</div>
                     <div class="bContent">
                           <el-form-item prop="contactPerson">
                               <el-input size="medium" class="inpText" v-model="params1.contactPerson" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">
                         <span class="dot">*</span>
                         <span>联系电话</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="contactPhone">
                               <el-input size="medium" class="inpText" v-model="params1.contactPhone" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">申请网址</div>
                     <div class="bContent">
                           <el-form-item prop="url">
                               <el-input size="medium" class="inpText" v-model="params1.url" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave(3)" type="primary" size="small">保存</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
           <!-- <el-button @click="directSave(1)" type="primary" size="small">立即发布</el-button>
           <el-button @click="directSave(2)" plain size="small">存为草稿</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button> -->
      </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { msgCreate,assCreate,msgPredat } from "@/api/message/message";
import { dicSeek } from "@/api/pgMent/dictMent";
let isPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('联系电话不能为空'));
    }else{
        let pattern = /^1[3|4|5|7|8][0-9]{9}$/;
        if(pattern.test(value)){
            callback();
        }else{
            return callback(new Error('联系电话格式不正确'));
        }
    }
}
export default {
    components:{
        Editor
    },
    computed:{
      pgState:function(){
          var state = 0;
          if(this.id && !this.readyKey){
              state = 1;
          }

          if(this.uploadIng){
              state = 2;
          }
          return state;
      }
    },
    data(){
        return{
            id:'',
            pageH:'',

            uploadIng:false,
            readyKey:false,

            params1:{
                id:'',
                businessNewsId:'',
                url:'',
                title:'',
                contactPerson:'',   // 联系人
                contactPhone:'',    // 联系电话
                tagNames:'',
                status:0,
            },

            params2:{
                id:'',
                businessNewsId:'',
                membershipRequirements:'',
                submitMaterial:'',
                membershipProcess:''
            },

            preCode:'',
            pgName:'',

            rules:{
                title:[{
                      required: true,
                      message:'标题不能为空',
                      trigger: 'blur'
                }],
                contactPhone:[{
                      validator: isPhone,
                      trigger: 'blur'
                }],
            }

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        selectChange:function(e){
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
        },

        goCreate:async function(status){  // 创建
            var vues = this;
            var promiseArr = [];

            vues.params2.membershipRequirements = this.$refs.textEditor1.editorContent;
            vues.params2.submitMaterial = this.$refs.textEditor2.editorContent;
            vues.params2.membershipProcess = this.$refs.textEditor3.editorContent;
            vues.params1.status=status;
            try {
              await msgCreate({businessNews:vues.params1}).then(res => {
                  if(!vues.params2.businessNewsId){
                      vues.params2.businessNewsId = res.businessNews.id;
                  }
              })
              await assCreate({businessAssociationDetails:vues.params2});
              vues.$router.push('ass_message');
            } catch (e) {
              vues.$message.error('保存错误！');
            } finally {
              vues.uploadIng = true;
            }
        },

        tmSave:function(){
            var vues = this;
            this.waitSave = setInterval(function(){
                var nowCode = JSON.stringify(vues.params);
                if(nowCode !== vues.preCode){
                    vues.goCreate(2);
                    vues.preCode = nowCode;
                }
            },60000)
        },

        directSave:function(status){
            var vues = this;
            vues.params2.membershipRequirements = this.$refs.textEditor1.editorContent;
            vues.params2.submitMaterial = this.$refs.textEditor2.editorContent;
            vues.params2.membershipProcess = this.$refs.textEditor3.editorContent;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    if(!vues.params2.membershipRequirements){
                        vues.$message.error('入会条件不能为空!');
                    }else{
                        vues.goCreate(status);
                    }
                }
            })
        },

        imgChange:function(e){
            this.params.coverImage = e;
        },

        // 标签
        tagChange:function(e){
            this.params1[e.paramsKey] = e.id;
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            this.params1.businessNewsTypeId = querys.typeid;

            // 底部定位
            this.pageFix();

            if(querys && querys.id){
                this.id = querys.id;
                this.params1.id = querys.id;
                this.params2.businessNewsId = querys.id;
                msgPredat({id:querys.id}).then(res => {
                    vues.readyKey = true;
                    vues.params1 = res.businessNews;
                    if(res.businessAssociationDetails){
                         vues.params2 = res.businessAssociationDetails;
                    }

                })
            }else{
                this.preCode = JSON.stringify(this.params);
                // this.tmSave();
                msgCreate({businessNews:this.params1}).then(res => {
                    vues.params1.id = res.businessNews.id;
                    vues.params2.businessNewsId = res.businessNews.id;
                })
            }

        },
    },
    created:function(){
        var vues = this;

        $(window).on('resize',function(){
    		     vues.pageFix();
             vues.$refs.scroller.sizeHeight = this.pageH;
    	  })

        this.prevSet();


    },

    beforeDestroy:function(){
        $(window).off('resize');
        clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 80px;
          padding-top: 8px;
          float: left;
          .dot{
              color: salmon;
              display: inline-block;
              vertical-align: middle;
              margin-top: 3px;
          }
     }
     .bContent{
          margin-left: 80px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }
     }
}

.radio-block .el-radio-group{
     margin-top: 12px;
}

.tag-block{
   margin-top:20px;
   .bName{
        padding-top: 5px;
   }
}


</style>

<style lang="css">

.atvEdit .el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// assEdit.vue?0decb204